import { AbstractControl } from '@angular/forms';

import { FormValidatorTypeKeys } from '../constants/form.constants';
import { IFormValidator } from '../models/form.model';

export class FormHelper {
  static getErrorMessages(formControl: AbstractControl | null, controlValidators: IFormValidator[], filter?: string[]): string[] {
    const errorMessages: string[] = [];
    for (const item in formControl?.errors) {
      if (!filter || filter.indexOf(item) > -1) {
        const validatorError = controlValidators.find((x: IFormValidator) => x.validator.getKey() === item);
        if (validatorError) {
          const message = validatorError?.errorMessage;
          if (message) {
            errorMessages.push(message);
          }

          continue;
        }

        const wrapperValidatorError = controlValidators.find((x: IFormValidator) => x.validator.getKey() === FormValidatorTypeKeys.wrapper);
        if (wrapperValidatorError) {
          const message = wrapperValidatorError.errorMessages?.[item];
          if (message) {
            errorMessages.push(message);
          }
        }
      }
    }

    return errorMessages;
  }

  static getHtmlErrorMessages(
    formControl: AbstractControl | null,
    controlValidators: IFormValidator[],
    filter?: string[]
  ): { withHtml: string[]; withoutHtml: string[] } {
    const checkForHtmlTags = /<\/?[a-z][\s\S]*>/i;
    const errorMessages = FormHelper.getErrorMessages(formControl, controlValidators, filter);

    return errorMessages.reduce(
      (result, errorMessage) => {
        if (checkForHtmlTags.test(errorMessage)) {
          result.withHtml.push(errorMessage);
        } else {
          result.withoutHtml.push(errorMessage);
        }
        return result;
      },
      { withHtml: [] as string[], withoutHtml: [] as string[] }
    );
  }
}
